import { useParams } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { FC } from 'react';
import { $ABTest, $RootTraffic } from '@lemon8/web-app-shared/atom';
import _get from 'lodash/get';
import { $PageLevelTraffic } from 'shared/atoms';

export const DiscoverSmartBanner: FC = () => {
  const { keyword } = useParams();
  const mediaSource = 'smart_banner_seo_discover';
  const { versions, parameters } = useAtomValue($ABTest);
  const showSmartBanner = Boolean(_get(parameters, 'seo_web.show_safari_smart_banner'));
  const { seoPageId } = useAtomValue($PageLevelTraffic);
  const { trafficPid } = useAtomValue($RootTraffic);
  const ampExtra = {
    traffic_type: trafficPid,
    enter_page_type: 'discover',
    enter_position: 'smart_banner',
    enter_page_id: keyword,
    seo_page_id: seoPageId,
  };

  return (
    <>
      {showSmartBanner && (
        <meta
          name="apple-itunes-app"
          content={`app-id=1498607143, app-argument=https://lemon8.onelink.me/FMQw?pid=${mediaSource}&ab_version=${encodeURIComponent(
            versions,
          )}&amp_extra=${encodeURIComponent(JSON.stringify(ampExtra))}, affiliate-data=pt=125533089&ct=${mediaSource}`}
        />
      )}
    </>
  );
};
